module.exports = __webpack_public_path__ + "static/img/1.ffc2b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/1.png
// module id = 7M+6
// module chunks = 0